import React from 'react';
import moment from 'moment';
import FormOption from '../../../_components/Options/FormOption';
import AvailableOn from './Component/AvailableOn';
import LocationOption from '../../../_components/Options/LocationOption';
import ReactDatePicker from '../../../_components/DatePicker/ReactDatePicker';
import ProfessionalOption from '../../../_components/Options/ProfessionalOption';

import { Component } from 'react';

import "react-datepicker/dist/react-datepicker.css";

const CURRENT_STEP = 'FORM_DETAILS';

class FormDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      errors: [],
    }

    this.validate = this.validate.bind(this);
  }

  validate(e) {
    e.preventDefault();

    let errors = {};

    if (!this.props.completeByDate) {
      errors.dateTime = 'Complete By Date is required.'
    } else if (moment(this.props.completeByDate).isBefore(new Date())) {
      errors.dateTime = 'Complete By Date must be upcoming.';
    }

    if (!this.props.groupId) {
      errors.group = 'Location is required.'
    }

    if (!this.props.providerId) {
      errors.provider = 'Provider is required.'
    }

    if (!this.props.formId) {
      errors.form = 'Form is required.'
    }

    if (this.props.availableOn && moment(this.props.availableOn).isSameOrBefore(moment())) {
      errors.availableOn = 'Available On must be an upcoming date.';
    }

    if (this.props.availableOn && this.props.completeByDate && moment(this.props.availableOn).isSameOrAfter(moment(this.props.completeByDate))) {
      errors.availableOn = 'Available On must be before Complete By Date.';
    }

    this.setState({ errors });

    if (!errors.dateTime && !errors.provider && !errors.group && !errors.form && !errors.availableOn) {
      this.props.saveForm();
    }
  }

  renderValidateMessage(field) {
    const message = this.state.errors[field];

    return (
      <div id={`${field}-error`} className="text-danger hide">{message}</div>
    );
  }

  render() {
    if (this.props.currentStep !== CURRENT_STEP) {
      return null;
    }

    const {
      formId,
      groupId,
      setValue,
      isSaving,
      providerId,
      availableOn,
      completeByDate,
    } = this.props;

    return (
      <div className="card axs-shadow">
        <div className="card-body">
          <h3 className="d-inline font-weight-bold">Send Form</h3>&nbsp;
          <h6 className="ml-3 d-inline font-weight-bold text-muted">Form Details</h6>
          <hr />

          <form className="mt-4">
            <div className="form-group">
              <div className="row">
                <div className="col-sm-4">
                  <label><span className="text-danger">*</span> Provider</label>
                  <ProfessionalOption defaultValue={providerId} handleSelected={(value) => setValue('providerId', value)} />
                  {this.renderValidateMessage('provider')}
                </div>
                <div className="col-sm-4">
                  <label><span className="text-danger">*</span> Location</label>
                  <LocationOption defaultValue={groupId} handleSelected={(value) => setValue('groupId', value)} />
                  {this.renderValidateMessage('group')}
                </div>
                <div className="col-sm-4">
                  <label><span className="text-danger">*</span> Form</label>
                  <FormOption defaultValue={formId} handleSelected={(value) => setValue('formId', value)} />
                  {this.renderValidateMessage('form')}
                </div>
              </div>
            </div>

            <br />

            <div className="form-group">
              <div className="row">
                <div className="col-sm-4">
                  <label><span className="text-danger">*</span> Complete By Date</label>
                  <ReactDatePicker
                    selected={completeByDate}
                    onChange={(date) => setValue('completeByDate', date)}
                    minDate={new Date()}
                    showTimeSelect
                    timeFormat="hh:mm aa"
                    timeIntervals={5}
                    dateFormat="MMM d, yyyy h:mm aa"
                    className="form-control"
                    wrapperClassName="w-100"
                  />
                  {this.renderValidateMessage('dateTime')}
                </div>
                <div className="col-sm-4">
                  <AvailableOn
                    sendOn={availableOn}
                    setAvailableOn={(date) => setValue('availableOn', date)}
                    apptDate={completeByDate}
                    apptType="axs-link" />
                  {this.renderValidateMessage('availableOn')}
                </div>
              </div>
            </div>
          </form>
        </div>

        <br />

        <div className="card-footer">
          <div className="row">
            <div className="col-sm-2">
              <button
                disabled={isSaving}
                onClick={this.props.backStep}
                type="submit" className="btn btn-outline-primary btn-block">Back</button>
            </div>
            <div className="col-sm-4">
              <button
                onClick={this.validate}
                disabled={isSaving}
                type="submit" className="btn btn-primary btn-block">
                {isSaving ? <i className="fa fa-spinner fa-spin fa-fw"></i> : 'Send Form'}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default FormDetails;